var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card mt-4" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("h2", { staticClass: "card-title" }, [
        _vm._v(_vm._s(_vm.T.loginSignupHeader))
      ])
    ]),
    _c("div", { staticClass: "card-body" }, [
      !_vm.useSignupFormWithBirthDate
        ? _c("form", [
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-username" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginAccountName))
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-username": "",
                        name: "reg_username",
                        autocomplete: "username"
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-email" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginEmail))
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      "data-signup-email": "",
                      name: "reg_email",
                      type: "email",
                      autocomplete: "email"
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-password" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginPasswordCreate))
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-password": "",
                        name: "reg_password",
                        type: "password",
                        autocomplete: "new-password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-confirmpassword" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginRepeatPassword))
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirmation,
                        expression: "passwordConfirmation"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      "data-signup-repeat-password": "",
                      name: "reg_password_confirmation",
                      type: "password",
                      autocomplete: "new-password"
                    },
                    domProps: { value: _vm.passwordConfirmation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.passwordConfirmation = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-8 introjs-terms-and-conditions" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.termsAndPolicies,
                        expression: "termsAndPolicies"
                      }
                    ],
                    attrs: {
                      "data-signup-accept-policies": "",
                      type: "checkbox",
                      required: ""
                    },
                    domProps: {
                      checked: Array.isArray(_vm.termsAndPolicies)
                        ? _vm._i(_vm.termsAndPolicies, null) > -1
                        : _vm.termsAndPolicies
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.termsAndPolicies,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.termsAndPolicies = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.termsAndPolicies = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.termsAndPolicies = $$c
                        }
                      }
                    }
                  }),
                  _c(
                    "label",
                    { attrs: { for: "checkbox" } },
                    [
                      _c("omegaup-markdown", {
                        attrs: { markdown: _vm.formattedAcceptPolicyMarkdown }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm.validateRecaptcha
                ? _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("vue-recaptcha", {
                        attrs: {
                          name: "recaptcha",
                          sitekey: "6LfMqdoSAAAAALS8h-PB_sqY7V4nJjFpGK2jAokS"
                        },
                        on: { verify: _vm.verify, expired: _vm.expired }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("div", { staticClass: "col-md-4 col-md-offset-6" }, [
                _c("div", { staticClass: "form-group introjs-register" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary form-control",
                      attrs: {
                        "data-signup-submit": "",
                        name: "sign_up",
                        type: "submit"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("register-and-login", {
                            username: _vm.username,
                            email: _vm.email,
                            password: _vm.password,
                            passwordConfirmation: _vm.passwordConfirmation,
                            recaptchaResponse: _vm.recaptchaResponse,
                            termsAndPolicies: _vm.termsAndPolicies
                          })
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.loginSignUp) + " ")]
                  )
                ])
              ])
            ])
          ])
        : _c("form", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-4 offset-md-2" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.over13Checked,
                        expression: "over13Checked"
                      }
                    ],
                    attrs: {
                      type: "checkbox",
                      "data-over-thirteen-checkbox": ""
                    },
                    domProps: {
                      checked: Array.isArray(_vm.over13Checked)
                        ? _vm._i(_vm.over13Checked, null) > -1
                        : _vm.over13Checked
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.over13Checked,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.over13Checked = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.over13Checked = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.over13Checked = $$c
                          }
                        },
                        _vm.updateDateRestriction
                      ]
                    }
                  }),
                  _c(
                    "label",
                    { staticClass: "pl-1", attrs: { for: "checkbox" } },
                    [
                      _c("omegaup-markdown", {
                        attrs: { markdown: _vm.T.over13yearsOld }
                      })
                    ],
                    1
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _vm.isUnder13
                ? _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(_vm._s(_vm.T.loginParentEmail))
                      ]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.parentEmail,
                            expression: "parentEmail"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          name: "reg_parent_email",
                          type: "email",
                          autocomplete: "parent-email"
                        },
                        domProps: { value: _vm.parentEmail },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.parentEmail = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "col-md-8 offset-md-2 introjs-email" },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "control-label" }, [
                          _vm._v(_vm._s(_vm.T.loginEmail))
                        ]),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            "data-signup-email": "",
                            name: "reg_email",
                            type: "email",
                            autocomplete: "email"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  )
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-username" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginAccountName))
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.username,
                          expression: "username"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-username": "",
                        name: "reg_username",
                        autocomplete: "username"
                      },
                      domProps: { value: _vm.username },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.username = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              ),
              _c("div", { staticClass: "col-md-4" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginDateOfBirth))
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.dateOfBirth,
                        expression: "dateOfBirth"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "reg_date_of_birth",
                      type: "date",
                      autocomplete: "date-of-birth",
                      max: _vm.maxDateForTimepicker,
                      min: _vm.minDateForTimepicker
                    },
                    domProps: { value: _vm.dateOfBirth },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.dateOfBirth = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-4 col-md-offset-2 introjs-password" },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "control-label" }, [
                      _vm._v(_vm._s(_vm.T.loginPasswordCreate))
                    ]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.password,
                          expression: "password"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        "data-signup-password": "",
                        name: "reg_password",
                        type: "password",
                        autocomplete: "new-password"
                      },
                      domProps: { value: _vm.password },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.password = $event.target.value
                        }
                      }
                    })
                  ])
                ]
              ),
              _c("div", { staticClass: "col-md-4 introjs-confirmpassword" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { staticClass: "control-label" }, [
                    _vm._v(_vm._s(_vm.T.loginRepeatPassword))
                  ]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.passwordConfirmation,
                        expression: "passwordConfirmation"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      "data-signup-repeat-password": "",
                      name: "reg_password_confirmation",
                      type: "password",
                      autocomplete: "new-password"
                    },
                    domProps: { value: _vm.passwordConfirmation },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.passwordConfirmation = $event.target.value
                      }
                    }
                  })
                ])
              ])
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c(
                "div",
                { staticClass: "col-md-10 introjs-terms-and-conditions" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.termsAndPolicies,
                        expression: "termsAndPolicies"
                      }
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.termsAndPolicies)
                        ? _vm._i(_vm.termsAndPolicies, null) > -1
                        : _vm.termsAndPolicies
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.termsAndPolicies,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.termsAndPolicies = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.termsAndPolicies = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.termsAndPolicies = $$c
                        }
                      }
                    }
                  }),
                  _c(
                    "label",
                    { staticClass: "pl-1", attrs: { for: "checkbox" } },
                    [
                      _c("omegaup-markdown", {
                        attrs: { markdown: _vm.formattedAcceptPolicyMarkdown }
                      })
                    ],
                    1
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _vm.validateRecaptcha
                ? _c(
                    "div",
                    { staticClass: "col-md-4" },
                    [
                      _c("vue-recaptcha", {
                        attrs: {
                          name: "recaptcha",
                          sitekey: "6LfMqdoSAAAAALS8h-PB_sqY7V4nJjFpGK2jAokS"
                        },
                        on: { verify: _vm.verify, expired: _vm.expired }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "row justify-content-md-center" }, [
              _c("div", { staticClass: "col-md-4 col-md-offset-6" }, [
                _c("div", { staticClass: "form-group introjs-register" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary form-control",
                      attrs: { "data-signup-submit": "", name: "sign_up" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$emit("register-and-login", {
                            over13Checked: _vm.over13Checked,
                            username: _vm.username,
                            email: _vm.email,
                            dateOfBirth: _vm.dateOfBirth,
                            parentEmail: _vm.parentEmail,
                            password: _vm.password,
                            passwordConfirmation: _vm.passwordConfirmation,
                            recaptchaResponse: _vm.recaptchaResponse,
                            termsAndPolicies: _vm.termsAndPolicies
                          })
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.T.loginSignUp) + " ")]
                  )
                ])
              ])
            ])
          ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }